import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Body4 } from '../../typography';
import {
  HotelSectionContainer,
  HotelSelectionTitleText,
  HotelSelectionSubTitleText,
  HotelSectionContent,
  ListSectionContainer,
  ListSectionContent,
  ListSectionItem,
  SearchContainer,
  NoResultContainer,
  ListBrandName,
  ListItemName,
} from './styled.subHeaderSelector';
import { NullSorting } from './../../icons/NullSorting';
import { BottomSheet } from './../BottomSheet';
import { SearchField } from './../SearchField';
import { SearchIcon } from './../../icons/SearchIcon';
import { CheckMark } from './../../icons/CheckMark';
import EmptySearch from './../../icons/EmptySearch';
import {
  ISubHeaderSelector,
  IListSelector,
} from './../../../@types/subHeaderSelector';

export function SubHeaderSelector ({
  title,
  subTitle,
  listSelector,
  clickSelectSection,
}: ISubHeaderSelector) {
  const [isHotelSectionModalOpen, setIsHotelSectionModalOpen] =
    useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>('');
  const [localListOfSelections, setLocalListOfSelections] =
    useState<IListSelector[]>(listSelector);

  const { t } = useTranslation();

  function toggleBottomSheet () {
    setIsHotelSectionModalOpen(() => !isHotelSectionModalOpen);
    setSearchText('');
  }

  useEffect(() => {
    setLocalListOfSelections(listSelector);
    const filteredItems: IListSelector[] = listSelector.filter(
      (item: IListSelector) => {
        const searchTextLowerCase = searchText.toLowerCase();
        return !(
          searchText &&
          item &&
          !item.name.toLowerCase().includes(searchTextLowerCase) &&
          !item.brandName.toLowerCase().includes(searchTextLowerCase)
        );
      }
    );
    setLocalListOfSelections(filteredItems);
  }, [searchText, listSelector]);

  return (
    <div>
      <HotelSectionContainer data-testid="sub-header-selector">
        <HotelSelectionTitleText>{title}</HotelSelectionTitleText>
        <HotelSectionContent onClick={() => toggleBottomSheet()}>
          <HotelSelectionSubTitleText>{subTitle}</HotelSelectionSubTitleText>
          <NullSorting />
        </HotelSectionContent>
      </HotelSectionContainer>

      <BottomSheet
        isOpen={isHotelSectionModalOpen}
        onClose={toggleBottomSheet}
        title={t('COMMON.MY_AUDIT.TITLES.CHOOSE_HOTEL')}
      >
        <SearchContainer>
          <SearchField
            icon={<SearchIcon />}
            placeholderText={t(
              'COMMON.MY_AUDIT.GENERIC_FIELDS.START_TYPING_TO_SELECT'
            )}
            textValue={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onClearTextValue={() => setSearchText('')}
            data-testid="sub-header-selector-search-field"
          />
        </SearchContainer>
        <ListSectionContainer>
          {localListOfSelections.length ? (
            localListOfSelections.map((item: IListSelector) => (
              <ListSectionContent
                key={`${item.id}-${item.brandId}-${item.clientId}`}
                isActive={item.selected}
                onClick={() => {
                  clickSelectSection(item.id, item.clientId, item.brandId);
                  setIsHotelSectionModalOpen(false);
                }}
                data-testid="sub-header-selector-search-field-select"
              >
                <ListSectionItem>
                  <ListBrandName isActive={item.selected}>
                    {item.brandName}
                  </ListBrandName>
                  <ListItemName isActive={item.selected}>
                    {item.name}
                  </ListItemName>
                </ListSectionItem>
                {item.selected && <CheckMark />}
              </ListSectionContent>
            ))
          ) : (
            <NoResultContainer>
              <Body4 color="battleShipGray">
                {t('COMMON.ALERT_MESSAGES.NO_RESULTS_FOUND_BY_TYPING')}
              </Body4>
              <EmptySearch />
            </NoResultContainer>
          )}
        </ListSectionContainer>
      </BottomSheet>
    </div>
  );
}
